<template>
    <div>
        <div>
            <b-breadcrumb>
                <b-breadcrumb-item :to="{ name: 'Home' }">Inicio</b-breadcrumb-item>
                <b-breadcrumb-item :to="{ name: 'Worker' }">Operadores</b-breadcrumb-item>
                <b-breadcrumb-item v-if="$route.name !== 'Worker'">{{ $route.meta.title }}</b-breadcrumb-item>
            </b-breadcrumb>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>
